import React from 'react';
import { useDispatch } from 'react-redux';
import {
    StyledPopUpBlock,
    StyledPopUpContainer,
    StyledHeader,
} from '../styled';
import { hidePopupWindow } from '../../../redux/actions/Popups';
import { StyledLinksWrapper, StyledStoreLink } from '../../../page/StartPage/styled';
import DownloadAppStore from '../../../assets/img/download-appstore.png';
import DownloadGooglePlay from '../../../assets/img/download-gplay.png';
import { StyledCrossMobileRequired, StyledParagraphMobileRequired, StyledPopUpMobile } from './styled';


const MobileRequired = ({ popupName }) => {
    const dispatch = useDispatch();

    const hidePopup = () => {
        dispatch(hidePopupWindow(popupName));
    };

    const goToUrl = (url) => window.open(url, '_blank');
    return (
        <StyledPopUpMobile>
            <StyledPopUpBlock maxWidth={600}>
                <StyledCrossMobileRequired onClick={() => hidePopup()} />
                <StyledPopUpContainer>
                    <StyledHeader>Mobile app required</StyledHeader>
                    <StyledParagraphMobileRequired>To access this feature please download and subscribe/purchase on our mobile application</StyledParagraphMobileRequired>

                    <StyledLinksWrapper>
                        <StyledStoreLink
                            onClick={() =>
                                goToUrl('https://play.google.com/store/apps/details?id=com.theopenleague&hl=en_US')
                            }
                        >
                            <img src={DownloadGooglePlay} alt="Get it on Google Play" />
                        </StyledStoreLink>
                        <StyledStoreLink
                            onClick={() =>
                                goToUrl('https://apps.apple.com/br/app/the-open-league/id6593708943?l=en-GB')
                            }
                        >
                            <img src={DownloadAppStore} alt="Download on the App Store" />
                        </StyledStoreLink>
                    </StyledLinksWrapper>
                </StyledPopUpContainer>
            </StyledPopUpBlock>
        </StyledPopUpMobile>
    );
};

export default React.memo(MobileRequired);
